import script from "./MagicRings.vue?vue&type=script&setup=true&lang=js"
export * from "./MagicRings.vue?vue&type=script&setup=true&lang=js"

import "./MagicRings.vue?vue&type=style&index=0&id=efd2bd74&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efd2bd74"]])

export default __exports__